<template>
  <div
    :data-e2e="PolicyConsentPlaywrightAttributes.views.POLICY_CONSENT_MODAL"
    id="container"
    class="is-full-absolute has-background-white"
  >
    <section class="px-4 is-full-height">
      <LoginHeader class="header" :show-language-button="true" />

      <ValidationObserver v-slot="{ invalid }">
        <ConfirmModal
          :primary-button-text="$t('core.next')"
          :confirm-fn="save"
          :is-primary-button-disabled="invalid"
          :hide-cancel="true"
        >
          <template #body>
            <div class="columns is-centered m-t-50">
              <div>
                <h1 class="title has-text-primary">
                  {{ $t('consent.policy-updated-title') }}
                </h1>
                <h2 class="subtitle has-text-black has-text-weight-bold is-size-4 m-t-5">
                  {{ $t('consent.policy-updated-subtitle') }}
                </h2>
                <FormCheckbox
                  :data-e2e="PolicyConsentPlaywrightAttributes.inputs.TERMS_OF_USE_CHECKBOX"
                  v-model="terms"
                  :rules="{ required: true }"
                >
                  <span>{{ $t('billing.read-to-the') }}</span>
                  <span
                    class="is-link has-text-weight-semibold"
                    @click.stop.prevent="showTermsOfUseModal"
                    :data-e2e="PolicyConsentPlaywrightAttributes.inputs.SHOW_TERM_OF_USE_MODAL"
                  >
                    {{ $t('billing.terms-of-use') }}
                  </span>
                </FormCheckbox>

                <FormCheckbox
                  :data-e2e="PolicyConsentPlaywrightAttributes.inputs.PRIVACY_POLICY_CHECKBOX"
                  v-model="privacy"
                  :rules="{ required: true }"
                >
                  <span>{{ $t('billing.read-to-the-singular') }}</span>
                  <span
                    class="is-link has-text-weight-semibold"
                    @click.stop.prevent="showPrivacyPolicyModal"
                    :data-e2e="PolicyConsentPlaywrightAttributes.inputs.SHOW_PRIVACY_POLICY_MODAL"
                  >
                    {{ $t('billing.privacy-policy') }}
                  </span>
                </FormCheckbox>
              </div>
            </div>
          </template>
        </ConfirmModal>
      </ValidationObserver>
    </section>
  </div>
</template>
<script>
import LoginHeader from '@/modules/auth/components/LoginHeader.vue';
import FormCheckbox from '@/modules/core/form/components/FormCheckbox.vue';
import { OpensPolicyModalMixin } from '@/modules/billing/components/mixins/OpensPolicyModalMixin';
import ModalService from '@/modules/core/ui/services/ModalService';
import { HasAuthUserMixin } from '@/modules/core/app/mixins/HasAuthUserMixin';
import { PolicyConsentCypressAttributes } from '@/modules/policyconsent/constants/PolicyConsentCypressAttributes';
import ConfirmModal from '@/modules/core/ui/components/ConfirmModal.vue';
import UserService from '@/modules/user/services/UserService';
import ValidationObserver from '/@/modules/core/form/components/ValidationObserver.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'PolicyConsentModal',
  mixins: [OpensPolicyModalMixin, HasAuthUserMixin],
  components: { ConfirmModal, FormCheckbox, LoginHeader, ValidationObserver },
  static: {
    PolicyConsentPlaywrightAttributes: PolicyConsentCypressAttributes
  },
  data() {
    return {
      terms: false,
      privacy: false,
      user: null
    };
  },
  methods: {
    async save() {
      this.user.policyConsentLastGivenAt = new Date();

      await UserService.saveEntity(this.user, this.user.id);

      ModalService.close();
    }
  },
  created() {
    this.user = this.authUser.user;
  }
};
</script>

<style scoped>
#container {
  .title {
    color: var(--ce-primary);
    margin-bottom: var(--ce-30px);
    font-size: var(--ce-36px);
    line-height: var(--ce-50px);
    text-indent: var(--ce-2px);
  }
}

.header {
  height: 16%;
}
</style>
